import { Link } from '@cian/ui-kit/link';
import * as React from 'react';

import * as styles from './styles.css';

export interface ICompareToastContentProps {
  text: string;
  comparisonUrl?: string;
  onClick?: () => void;
}

export function CompareToastContent({ text, comparisonUrl, onClick }: ICompareToastContentProps) {
  return (
    <div className={styles['container']}>
      <span>{text}</span>
      {comparisonUrl && (
        <span className={styles['link']}>
          <Link
            href={comparisonUrl}
            onClick={onClick}
            color="current_color"
            fontSize="M"
            fontWeight="bold"
            inline
            target="blank"
          >
            Посмотреть
          </Link>
        </span>
      )}
    </div>
  );
}
